<template>
  <div class="card">
    <div class="card-header">
      Monitor Dashboard
    </div>
    <div class="p-6">
      <div class="text-gray-500">
        Push alerts for this automation into the <router-link :to="{ name: 'MonitorMap' }">monitor dashboard</router-link> whenever it is triggered, and require an acknowledgement message.
      </div>
      <label class="flex mt-6 form-label">
        <toggle :value.sync="form.trigger_dashboard_alert" :sync="true" :width="60" :labels="true" class="mr-4" /> 
        <div class="leading-tight">
          Dashboard Monitor Alert
          <div class="text-sm font-normal text-gray-500">
            Push an alert to the <router-link :to="{ name: 'MonitorMap' }">monitor dashboard</router-link> whenever this automation rule is triggered.
          </div>
        </div>
      </label>
      <label class="flex mt-6 form-label" :class="{ 'opacity-25': !form.trigger_dashboard_alert }">
        <toggle :value.sync="form.require_acknowledgement" :sync="true" :width="60" :labels="true" class="mr-4" /> 
        <div class="leading-tight">
          Require Acknowledgement
          <div class="text-sm font-normal text-gray-500">
            Require that a staff member needs to acknowledge this alert with a note.
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonitorCard',

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    }
  }
}
</script>